import {createContext} from 'react'
import {type ReturnType} from './types/return-type'

export const ToggleContext = createContext<ReturnType | null>(null)
